import React from 'react';
import './Bredcrum.css';
import arrow_icon from '../Assets/breadcrum_arrow.png';

const Bredcrum = ({ product }) => {

  if (!product) {
    return null;
  }

  return (
    <div className="bredcrum">
      HOME
      <img src={arrow_icon} alt="" />
      SHOP
      <img src={arrow_icon} alt="" />
      {product.category}
      <img src={arrow_icon} alt="" />
      {product.name}
    </div>
  );
};

export default Bredcrum;